import React from 'react';
import { ITaskProps } from '../model/types/task-props.interface';
import { BoardTask } from './BoardTask';
import { ListTask } from './ListTask';

//todo изменить интерфейс типов

export function Task({ type, uid, isDone }: ITaskProps) {
    if (type === 'board') {
        return <BoardTask uid={uid} type={type} />;
    }
    if (type === 'list') {
        return <ListTask uid={uid} type={type} isDone={isDone} />;
    }
}
